import { Box, VStack } from '@chakra-ui/react'
import { ReactNode } from 'react'

interface CenteredPageProps {
  children: ReactNode
  bg?: string
}

export function CenteredPage({ children, bg = '#09090b' }: CenteredPageProps) {
  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg={bg}>
      <VStack spacing={8} w="100%" maxW="400px" p={8} bg="gray.800" borderRadius="lg">
        {children}
      </VStack>
    </Box>
  )
} 